<div class="w-100 h-100 d-flex justify-content-center align-items-center">
  <spinner [size]="100"/>
</div>
